import React, { useState, useEffect,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateFormData } from "../../redux/dispatch";
import useRubriqueNav from "../../hooks/useRubriqueNav";
import RubriqueNav from "../shared/RubriqueNav";
import "./DecisionTherapeutique.css";
import toast from 'react-hot-toast';
import { saveDossier } from "../../redux/dispatch";
import SaveLoader from "../shared/SaveLoader";
import useConfidence from "../../hooks/useConfidence";
import ConfidenceLabel from "../shared/ConfidenceLabel";
import { API_BASE } from "../../config/api";
import PROTOCOLES from "../../data/protocoles";
import noImage from "../../assets/no-image.svg";
import Select from "react-select";
const RUBRIQUE = "decision_therapeutique";

const INITIAL = {
 protocole: {
  inclus:         "",
  nom_protocole:  "",
  id_protocole:   null,
  raisons:        "",
},
    projet_therapeutique: {
    chimiotherapie:      false,
    chimiotherapie_data: [],
    chirurgie:           false,
    chirurgie_data:      [],
    radiotherapie:       false,
    radiotherapie_data:  [],
    autres:              false,
    autres_data:         [],
    },
 comorbidites: [],
  allergies: {
    has_allergies: "",
    details:       "",
  },
};

const MOYENS = [
  { key: "chimiotherapie", label: "Chimiothérapie" },
  { key: "chirurgie",      label: "Chirurgie" },
  { key: "radiotherapie",  label: "Radiothérapie" },
  { key: "autres",         label: "Autres" },
];

const normalizeProjet = (saved) => {
  if (!saved) return { ...INITIAL.projet_therapeutique };
  const result = { ...saved };
  MOYENS.forEach(({ key }) => {
    const data = saved[`${key}_data`];
    result[`${key}_data`] = Array.isArray(data) ? data : [];
  });
  delete result.projet_global;
  return result;
};

const EMPTY_ITEM = { traitement: "", phases: "" };

const ProtocoleSearch = ({idValue, onSelect, borderColor }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    const fetchProtocoles = async () => {
      setLoading(true);
      setError(null);
      try {
        const json = { data: PROTOCOLES };
        setOptions((json.data || []).map((p) => ({ value: p.id, label: p.libelle })));
      } catch (e) {
        setError(e.message);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProtocoles();
  }, []);

  const selectedOption = options.find((o) => o.value === idValue) || null;

  return (
    <div>
      {loading && (
        <div style={{ fontSize: "0.8rem", color: "#64748b", marginBottom: "0.4rem" }}>
          ⏳ Chargement de la liste des protocoles...
        </div>
      )}
      {error && (
        <div style={{ fontSize: "0.8rem", color: "red", marginBottom: "0.4rem" }}>
          ⚠️ Erreur : {error}
        </div>
      )}

      <div style={{ display: "flex", alignItems: "center", border: `1px solid ${borderColor || "#e2e8f0"}`, borderRadius: "6px", background: "#f8fafc" }}>
        <span style={{ padding: "0.5rem 0.75rem", background: "#e2e8f0", color: "#374151", fontWeight: "600", fontSize: "0.875rem", whiteSpace: "nowrap", borderRight: "1px solid #cbd5e1", borderRadius: "6px 0 0 6px" }}>
          GFA-
        </span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Select
            options={options}
            isLoading={loading}
            isClearable
            placeholder="Rechercher un protocole..."
            value={selectedOption}
            onChange={(selected) => {
              onSelect(selected ? selected.label : "", selected ? selected.value : null);
            }}
            styles={{
              control: (base) => ({
                ...base,
                border: "none",
                boxShadow: "none",
                background: "transparent",
                borderRadius: "0 6px 6px 0",
              }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
            }}
            noOptionsMessage={() => "Aucun protocole trouvé"}
            loadingMessage={() => "Chargement..."}
          />
        </div>
      </div>
    </div>
  );
};

const ProjetTabs = ({ projet, setProjet, make, gcPT }) => {
  const [activeTab, setActiveTab] = useState("chimiotherapie");
  const [currentIndex, setCurrentIndex] = useState({
    chimiotherapie: 0,
    chirurgie:      0,
    radiotherapie:  0,
    autres:         0,
  });

  const getData = (key) =>
    Array.isArray(projet[`${key}_data`]) ? projet[`${key}_data`] : [];

  const setData = (key, newData) => make(setProjet)(`${key}_data`, newData);

    const handleCheck = (key, checked) => {
    make(setProjet)(key, checked);
    if (checked) {
        setData(key, [{ ...EMPTY_ITEM }]);
        setCurrentIndex((prev) => ({ ...prev, [key]: 0 }));
    } else {
        setData(key, []);
        setCurrentIndex((prev) => ({ ...prev, [key]: 0 }));
    }
    };

  const handleAdd = (key) => {
    const newData = [...getData(key), { ...EMPTY_ITEM }];
    setData(key, newData);
    setCurrentIndex((prev) => ({ ...prev, [key]: newData.length - 1 }));
  };

  const handleRemove = (key) => {
    const data = getData(key);
    if (data.length <= 1) return;
    const idx = currentIndex[key];
    const newData = data.filter((_, i) => i !== idx);
    setData(key, newData);
    setCurrentIndex((prev) => ({ ...prev, [key]: Math.max(0, idx - 1) }));
  };

  const handleFieldChange = (key, index, field, value) => {
    const updated = [...getData(key)];
    updated[index] = { ...updated[index], [field]: value };
    setData(key, updated);
  };

  return (
    <div>
      {/* ── Tabs ── */}
      <div className="dt-projet-tabs">
        {MOYENS.map(({ key, label }) => (
          <button key={key}
            className={`dt-projet-tab ${activeTab === key ? "dt-projet-tab--active" : ""}`}
            onClick={() => setActiveTab(key)}>
            {label}
            {projet[key] && <span className="dt-projet-tab-dot" />}
          </button>
        ))}
      </div>

      {/* ── Contenu tab active ── */}
      {MOYENS.filter(({ key }) => key === activeTab).map(({ key, label }) => {
        const data = getData(key);
        const idx = currentIndex[key] ?? 0;
        const item = data[idx] || {};

        return (
          <div key={key} className="dt-projet-tab-content">

            {/* Checkbox */}
            <label className="dt-checkbox-label" style={{ marginBottom: "1rem" }}>
              <input type="checkbox"
                checked={projet[key] === true}
                onChange={(e) => handleCheck(key, e.target.checked)} />
              Inclure {label}
              <ConfidenceLabel confidence={gcPT(key)} />
            </label>

            {/* Champs si coché */}
            {projet[key] === true && data.length > 0 && (
              <>
                {/* Champs du bloc courant */}
                <div className="dt-field-group">
                  <label>Traitement</label>
                  <input type="text" placeholder="Traitement..."
                    value={item.traitement ?? ""}
                    onChange={(e) => handleFieldChange(key, idx, "traitement", e.target.value)} />
                </div>
                <div className="dt-field-group">
                  <label>Phases</label>
                  <textarea rows={4} placeholder="Décrire les phases..."
                    value={item.phases ?? ""}
                    onChange={(e) => handleFieldChange(key, idx, "phases", e.target.value)} />
                </div>

                {/* Barre de navigation */}
                <div className="dt-projet-nav">
                  <select
                    value={idx}
                    onChange={(e) => setCurrentIndex((prev) => ({ ...prev, [key]: parseInt(e.target.value) }))}
                    className="dt-projet-select">
                    {data.map((_, i) => (
                      <option key={i} value={i}>Traitement {i + 1}</option>
                    ))}
                  </select>
                  <button onClick={() => handleAdd(key)} className="om-bloc-btn om-bloc-btn--add">
                    + Ajouter
                  </button>
                  <button onClick={() => handleRemove(key)}
                    disabled={data.length <= 1}
                    className="om-bloc-btn om-bloc-btn--remove">
                    🗑 Supprimer
                  </button>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

const normalizeComorbidites = (saved) => {
  if (Array.isArray(saved) && saved.length > 0) return saved;
  return [{ maladie: "", description: "", traitement: "" }];
};

const DecisionTherapeutique = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id }   = useParams();
  const rawImages = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.images || []);
  const IMAGES = rawImages.length > 0
    ? rawImages.map((img) => `${API_BASE}/${img.chemin_image}`)
    : [noImage];
  const { currentDossier, list } = useSelector((s) => s.dossiers);
  const dossier = currentDossier || list.find((d) => d.id === id) || null;
  const formulairesData  = useSelector((s) => s.formulaires.data);
  const savedProtocole   = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.protocole            || {});
  const savedProjet      = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.projet_therapeutique || {});
  const savedComorbidites= useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.comorbidites         || {});
  const savedAllergies   = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.allergies            || {});

  const [protocole,   setProtocole]   = useState({ ...INITIAL.protocole,            ...savedProtocole    });
  const [projet,      setProjet]      = useState(normalizeProjet(savedProjet));
    const [comorbidites, setComorbidites] = useState(normalizeComorbidites(savedComorbidites));
  const [allergies,   setAllergies]   = useState({ ...INITIAL.allergies,            ...savedAllergies    });
const [saving, setSaving] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);

    const protocoleRef    = useRef(protocole);
    const projetRef       = useRef(projet);
    const comorbiditesRef = useRef(comorbidites);
    const allergiesRef    = useRef(allergies);

    useEffect(() => { protocoleRef.current    = protocole;    }, [protocole]);
    useEffect(() => { projetRef.current       = projet;       }, [projet]);
    useEffect(() => { comorbiditesRef.current = comorbidites; }, [comorbidites]);
    useEffect(() => { allergiesRef.current    = allergies;    }, [allergies]);

  useEffect(() => {
    setProtocole({    ...INITIAL.protocole,            ...savedProtocole    });
    setProjet(normalizeProjet(savedProjet));
    setComorbidites(normalizeComorbidites(savedComorbidites));
    setAllergies({    ...INITIAL.allergies,            ...savedAllergies    });
  }, [id]);

// APRÈS
const { goNext, goPrev, goTo, suivante, precedente, indexCourant, total } = useRubriqueNav(RUBRIQUE);
  // ── Confidence ──────────────────────────────────────────────────────────────
  const { getConfidence } = useConfidence(id, RUBRIQUE);
  const gcP  = (field) => getConfidence("protocole",            field);
  const gcPT = (field) => getConfidence("projet_therapeutique", field);
  const gcA  = (field) => getConfidence("allergies",            field);

  const make = (setter) => (field, value) =>
    setter((prev) => ({ ...prev, [field]: value }));

    const handleSave = () => {
    dispatch(updateFormData(id, RUBRIQUE, "protocole",            protocoleRef.current));
    dispatch(updateFormData(id, RUBRIQUE, "projet_therapeutique", projetRef.current));
    dispatch(updateFormData(id, RUBRIQUE, "comorbidites",         comorbiditesRef.current));
    dispatch(updateFormData(id, RUBRIQUE, "allergies",            allergiesRef.current));
    };

    useEffect(() => {
      return () => {
        handleSave();
      };
    }, []);

    const handleSaveAll = async () => {
        setSaving(true);
    dispatch(updateFormData(id, RUBRIQUE, "protocole",            protocole));
    dispatch(updateFormData(id, RUBRIQUE, "projet_therapeutique", projet));
    dispatch(updateFormData(id, RUBRIQUE, "comorbidites",         comorbidites));
    dispatch(updateFormData(id, RUBRIQUE, "allergies",            allergies));
        try {
            const result = await dispatch(saveDossier());
            toast.success(result.message);
            navigate("/");
        } catch (err) {
            toast.error(err.response?.data?.message || "Erreur lors de la sauvegarde");
        }
    finally {
    setSaving(false);
  }
  };

  const handleCancel = () => {
    setProtocole({    ...INITIAL.protocole,            ...savedProtocole    });
    setProjet(normalizeProjet(savedProjet));
    setComorbidites(normalizeComorbidites(savedComorbidites));
    setAllergies({    ...INITIAL.allergies,            ...savedAllergies    });
  };

  const [currentComorb, setCurrentComorb] = useState(0);
  

  if (!dossier) {
    return (
      <div className="dt-no-dossier">
        <p>Aucun dossier sélectionné.</p>
        <button onClick={() => navigate("/")}>Retour à la liste</button>
      </div>
    );
  }

  return (
    <div className="dt-page">
         {saving && <SaveLoader />}
      {/* ── Header ── */}
      <header className="dt-header">
        <div className="dt-header-left">
          <button className="dt-back-btn" onClick={() => navigate("/")}>← Retour à la liste</button>
          <div>
            <h1 className="dt-title">Dossier {dossier.numero_dossier || dossier.id}</h1>
            <p className="dt-subtitle">Patient : {dossier.patient} &nbsp;|&nbsp; Service : {dossier.service}</p>
          </div>
        </div>
        <button className="dt-save-btn" onClick={handleSaveAll} disabled={saving}>Sauvegarder les modifications</button>
      </header>

      <div className="dt-body">
        {/* ── Colonne gauche : image ── */}
        <aside className="dt-image-panel">
          <div className="dt-image-header">
            <span className="dt-rubrique-label">Décision Thérapeutique</span>
            <span className="dt-image-counter">Image {imgIndex + 1} / {IMAGES.length}</span>
          </div>
          <div className="dt-image-viewer">
            <img src={IMAGES[imgIndex]} alt={`Page ${imgIndex + 1}`} className="dt-image" />
          </div>
          <div className="dt-image-nav">
            <button className="dt-nav-btn" onClick={() => setImgIndex((i) => Math.max(0, i - 1))} disabled={imgIndex === 0}>‹</button>
            <div className="dt-image-dots">
              {IMAGES.map((_, i) => (
                <span key={i} className={`dt-dot ${i === imgIndex ? "dt-dot--active" : ""}`} onClick={() => setImgIndex(i)} />
              ))}
            </div>
            <button className="dt-nav-btn" onClick={() => setImgIndex((i) => Math.min(IMAGES.length - 1, i + 1))} disabled={imgIndex === IMAGES.length - 1}>›</button>
          </div>
        </aside>

        {/* ── Colonne droite : formulaire ── */}
        <main className="dt-form-panel">
          <div className="dt-form-scroll">

            {/* ── Section 1 : Protocole ── */}
            <section className="dt-section">
              <h2 className="dt-section-title">Protocole</h2>
              <div className="dt-fields">
                <div className="dt-field-group">
                  <label>Patient inclus dans un protocole <ConfidenceLabel confidence={gcP("inclus")} /></label>
                  <div className="dt-oui-non">
                    <label className="dt-radio-label">
                      <input type="radio" name="inclus_protocole" value="oui"
                        checked={protocole.inclus === "oui"}
                        onChange={() => make(setProtocole)("inclus", "oui")} />
                      Oui
                    </label>
                    <label className="dt-radio-label">
                      <input type="radio" name="inclus_protocole" value="non"
                        checked={protocole.inclus === "non"}
                        onChange={() => make(setProtocole)("inclus", "non")} />
                      Non
                    </label>
                  </div>
                </div>
                {protocole.inclus === "oui" && (
                  <div className="dt-field-group">
                    <label>Nom du protocole <ConfidenceLabel confidence={gcP("nom_protocole")} /></label>
                    <ProtocoleSearch
                      value={protocole.nom_protocole}
                      idValue={protocole.id_protocole}
                      onSelect={(libelle, id) => {
                        make(setProtocole)("nom_protocole", libelle ? "GFA-" + libelle : "");
                        make(setProtocole)("id_protocole", id ?? null);
                      }}
                      borderColor={gcP("nom_protocole").color || undefined}
                    />
                  </div>
                )}
                {protocole.inclus === "non" && (
                  <div className="dt-field-group">
                    <label>Raisons de non-inclusion <ConfidenceLabel confidence={gcP("raisons")} /></label>
                    <textarea rows={3} placeholder="Préciser les raisons..."
                      value={protocole.raisons ?? ""}
                      onChange={(e) => make(setProtocole)("raisons", e.target.value)}
                      style={{ borderColor: gcP("raisons").color || undefined }} />
                  </div>
                )}
              </div>
            </section>

            <div className="dt-divider" />

            {/* ── Section 2 : Projet thérapeutique ── */}
          
            <section className="dt-section">
            <h2 className="dt-section-title">Projet thérapeutique de 1ère intention</h2>
            <div className="dt-fields">
                <div className="dt-field-group">
                <label>Moyens thérapeutiques</label>
                <ProjetTabs projet={projet} setProjet={setProjet} make={make} gcPT={gcPT} />
                </div>
            </div>
            </section>

            <div className="dt-divider" />

            {/* ── Section 3 : Co-morbidités ── */}
        <section className="dt-section">
            <h2 className="dt-section-title">Co-morbidités</h2>
            <div className="dt-fields">
                {comorbidites.length > 0 && (() => {
                const item = comorbidites[currentComorb] || {};
                return (
                    <>
                    <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
                        <div className="dt-field-group" style={{ flex: 1, minWidth: "150px" }}>
                        <label>Maladie</label>
                        <input type="text" placeholder="Maladie..."
                            value={item.maladie ?? ""}
                            onChange={(e) => {
                            const updated = [...comorbidites];
                            updated[currentComorb] = { ...updated[currentComorb], maladie: e.target.value };
                            setComorbidites(updated);
                            }} />
                        </div>
                        <div className="dt-field-group" style={{ flex: 2, minWidth: "200px" }}>
                        <label>Description</label>
                        <input type="text" placeholder="Description..."
                            value={item.description ?? ""}
                            onChange={(e) => {
                            const updated = [...comorbidites];
                            updated[currentComorb] = { ...updated[currentComorb], description: e.target.value };
                            setComorbidites(updated);
                            }} />
                        </div>
                        <div className="dt-field-group" style={{ flex: 2, minWidth: "200px" }}>
                        <label>Traitement</label>
                        <input type="text" placeholder="Traitement..."
                            value={item.traitement ?? ""}
                            onChange={(e) => {
                            const updated = [...comorbidites];
                            updated[currentComorb] = { ...updated[currentComorb], traitement: e.target.value };
                            setComorbidites(updated);
                            }} />
                        </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginTop: "0.75rem", paddingTop: "0.75rem", borderTop: "1px solid #e2e8f0" }}>
                        <select
                        value={currentComorb}
                        onChange={(e) => setCurrentComorb(parseInt(e.target.value))}
                        className="dt-projet-select">
                        {comorbidites.map((c, i) => (
                            <option key={i} value={i}>
                            {c.maladie?.trim() ? c.maladie.trim() : `Co-morbidité ${i + 1}`}
                            </option>
                        ))}
                        </select>
                        <button type="button" className="om-bloc-btn om-bloc-btn--add"
                        onClick={() => {
                            const newList = [...comorbidites, { maladie: "", description: "", traitement: "" }];
                            setComorbidites(newList);
                            setCurrentComorb(newList.length - 1);
                        }}>
                        + Ajouter
                        </button>
                        <button type="button" className="om-bloc-btn om-bloc-btn--remove"
                        disabled={comorbidites.length <= 1}
                        onClick={() => {
                            const newList = comorbidites.filter((_, i) => i !== currentComorb);
                            setComorbidites(newList);
                            setCurrentComorb(Math.max(0, currentComorb - 1));
                        }}>
                        🗑 Supprimer
                        </button>
                    </div>
                    </>
                );
                })()}
                
            </div>
        </section>

            <div className="dt-divider" />

            {/* ── Section 4 : Allergies ── */}
            <section className="dt-section">
              <h2 className="dt-section-title">Allergies</h2>
              <div className="dt-fields">
                <div className="dt-field-group">
                  <label>Allergies connues <ConfidenceLabel confidence={gcA("has_allergies")} /></label>
                  <div className="dt-oui-non">
                    <label className="dt-radio-label">
                      <input type="radio" name="allergies" value="oui"
                        checked={allergies.has_allergies === "oui"}
                        onChange={() => make(setAllergies)("has_allergies", "oui")} />
                      Oui
                    </label>
                    <label className="dt-radio-label">
                      <input type="radio" name="allergies" value="non"
                        checked={allergies.has_allergies === "non"}
                        onChange={() => make(setAllergies)("has_allergies", "non")} />
                      Non
                    </label>
                  </div>
                </div>
                {allergies.has_allergies === "oui" && (
                  <div className="dt-field-group">
                    <label>Détailler les allergies <ConfidenceLabel confidence={gcA("details")} /></label>
                    <textarea rows={4} placeholder="Décrire les allergies..."
                      value={allergies.details ?? ""}
                      onChange={(e) => make(setAllergies)("details", e.target.value)}
                      style={{ borderColor: gcA("details").color || undefined }} />
                  </div>
                )}
              </div>
            </section>

          </div>

          {/* ── Actions ── */}
          {/* <div className="dt-form-actions">
            <button className="dt-btn-save" onClick={handleSave}>Enregistrer</button>
            <button className="dt-btn-cancel" onClick={handleCancel}>Annuler</button>
          </div> */}


<RubriqueNav goNext={goNext} goPrev={goPrev} goTo={goTo} suivante={suivante} precedente={precedente} indexCourant={indexCourant} total={total} />        </main>
      </div>
    </div>
  );
};

export default DecisionTherapeutique;